module.exports = __webpack_public_path__ + "img/fitness2.8fe29b01.png";